const Button = ({ children, variant = 'primary', size = 'lg', className = '' }) => {
  const baseClasses = 'group relative inline-flex items-center justify-center gap-2 font-bold tracking-wider transition-all duration-500 ease-in-out focus:outline-none focus:ring-4 focus:ring-offset-2 transform will-change-transform overflow-hidden';
  const sizeClasses = {
    lg: 'px-10 py-5 text-base md:text-lg rounded-full',
    md: 'px-6 py-3 text-sm rounded-lg',
  };
  const variantClasses = {
    primary: 'bg-[#3498db] text-white shadow-lg hover:shadow-xl hover:-translate-y-1 focus:ring-blue-400',
    secondary: 'bg-gradient-to-r from-orange-400 via-pink-500 to-rose-500 text-white shadow-lg hover:shadow-xl hover:-translate-y-1 focus:ring-orange-300',
    tertiary: 'bg-gradient-to-r from-purple-600 via-violet-600 to-indigo-600 text-white shadow-lg hover:shadow-xl hover:-translate-y-1 focus:ring-purple-500',
    outline: 'bg-white border-2 border-[#3498db] text-[#3498db] hover:bg-[#3498db] hover:text-white focus:ring-blue-400',
  };

  return (
    <button className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}>
      <span className="absolute inset-0 bg-gradient-to-r from-white/20 via-white/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></span>
      <span className="absolute -inset-full bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-20 transition-opacity duration-300 blur-xl"></span>
      <span className="relative z-10 flex items-center gap-2">{children}</span>
    </button>
  );
};

export default Button;